export const moduleNamespace = 'productManager';

export const SET_SOFTWARE_PRICES = 'SET_SOFTWARE_PRICES';
export const SET_SUPPORT_ADDON_FIELD = 'SET_SUPPORT_ADDON_FIELD';
export const SET_SUPPORT_ADDON_PRICE_FIELD = 'SET_SUPPORT_ADDON_PRICE_FIELD';
export const SET_SOFTWARE_PRODUCT = 'SET_SOFTWARE_PRODUCT';
export const SET_SOFTWARE_PRODUCT_FIELD = 'SET_SOFTWARE_PRODUCT_FIELD';
export const SET_SOFTWARE_PRODUCT_PRICE_FIELD = 'SET_SOFTWARE_PRODUCT_PRICE_FIELD';
export const SET_ERRORS = 'SET_ERRORS';
export const TOGGLE_SUPPORT_ADDON = 'TOGGLE_SUPPORT_ADDON';
export const TOGGLE_ENABLED_CURRENCY = 'TOGGLE_ENABLED_CURRENCY';
export const SET_LOADING_STATE = 'SET_LOADING_STATE';

/**
 * Standard fallbacks for when a user has not entered their own product names.
 */
export const SOFTWARE_PRODUCT_CONTENT_FALLBACKS = {
  name: 'SEO Software',
};
export const SUPPORT_ADDON_CONTENT_FALLBACKS = {
  name: 'Software Support',
};
